import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from "dayjs";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const auditLogReport = createAsyncThunk('auditLogReport', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: getConfig.API_URL + `audit_log`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'user_id': data?.user_id,
                'fromDate': data?.fromDate ? dayjs(data?.fromDate, 'DD/MM/YYYY').format('YYYY/MM/DD') : '',
                'toDate': data?.toDate ? dayjs(data?.toDate, 'DD/MM/YYYY').format('YYYY/MM/DD') : '',
                ...(data?.premise_id ? { premise_id: data.premise_id } : {}),
                ...(data?.action_type ? { action_type: data.action_type } : {}),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const auditLogReportSlice = createSlice({
    name: 'auditLogReport',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(auditLogReport.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const body = action.payload.data
                state.data = Array.isArray(body?.data)
                    ? body.data
                    : (Array.isArray(body) ? body : []);
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(auditLogReport.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default auditLogReportSlice.reducer;